import { createReducer } from "../rootreducer/index";

const lazyLoadComponents = lazyModules => {
    return (location, cb) => {
        const moduleKeys = Object.keys(lazyModules);
        const promises = moduleKeys.map(
            key => new Promise(resolve => lazyModules[key](resolve))
        );

        Promise.all(promises).then(modules => {
            cb(
                null,
                modules.reduce(
                    (obj, module, i) => {
                        obj[moduleKeys[i]] = module;

                        return obj[moduleKeys[i]].default;
                    },
                    {}
                )
            );
        });
    };
};

export const lazyLoadComponent = (lazyModule, store, reducer) => {
    return (location, cb) => {
        //case 1: If the component is already downloaded and loaded and availiable i.e not any anonymous function but a 'class' directly call the call back
        if(lazyModule.toString().includes('class')){ return cb(null, lazyModule);}
        // case 2: else if the component is not loaded -- component is anonymous function
        else{
        lazyModule(module => {
            //If already loaded the dyanmic reducer -- just load the component -- component is already downloaded at this point-- so just loading it.
            if (store.asyncReducers[reducer.name]) {
                cb(null, module.default);
            } else {
                // if dynamic reducer not loaded -- load the reducer into the store and then load the component
                // import("../reducers/index").then(adminReducer => {
                //  Case 3: bundle of the component not downloaded
                    reducer.import().then(adminReducer => {
                    adminReducer(comp => {
                        store.asyncReducers[reducer.name] = comp.default;
                        store.replaceReducer(
                            createReducer(store.asyncReducers)
                        );
                        cb(null, module.default);
                    });
                });
                }
            });
       }
    };
};



// WEBPACK FOOTER //
// ./src/routes/routeUtils.js